<div class="text-not-allowed">
    <h2>Sorry, you are lacking the required permissions to use the dashboard.</h2>
</div>